<script>
import Header from '@/components/app/desktop/Header'
import Panel from '@/components/app/desktop/Panel'
import Features from '@/components/app/desktop/Features'
import FlightSharing from '@/components/app/shared/flight-sharing/FlightSharing'
import Fade from '@/components/transitions/Fade'

export default {
  components: { Header, Panel, Features, FlightSharing, Fade },
  state: {
    panelWidth: undefined,
  },
	mounted() {
		this.panelWidth = this.$refs.panel.$el.clientWidth

		window.addEventListener('resize', () => {
			this.panelWidth = this.$refs.panel.$el.clientWidth
		}, {
			passive: true,
		})
	},
	data() {
		return {
			panelWidth: this.panelWidth,
		}
	},
}
</script>

<template>
	<div class="flex flex-col">
		<div class="relative pt-12 pl-28 pr-20 pb-16 flex justify-center">
			<Fade>
				<div class="absolute inset-0 bg-cream-100" />
			</Fade>
			<div class="relative flex justify-between items-end gap-20 w-full max-w-screen-xl">
				<Header />
				<Panel ref="panel" class="-mb-56" />
			</div>
		</div>
		<Features
			v-if="panelWidth"
			:panelWidth="panelWidth"
		/>
		<FlightSharing />
	</div>
</template>
